import { Link, T, VStack } from 'govwell-ui'
import styled from 'styled-components'
import { FileFragment } from 'types/graphql'

import { useImageRetry } from 'src/hooks/use-image-retry'
import { isImage, isPdf } from 'src/utils/file'

type Props = {
  file: FileFragment
  renderImages: boolean
  renderPDFsInline?: boolean
}

const Image = styled.img<{ $isHidden: boolean }>`
  width: 100%;
  height: auto;
  ${({ $isHidden }) => ($isHidden ? 'visibility: hidden; position: absolute;' : '')}
`

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
`

const FileImage = ({ signedUrl }: { signedUrl: string }) => {
  const { hasError, imgSrc, onError, onLoad } = useImageRetry(signedUrl)
  return (
    <ImageContainer>
      <Image src={imgSrc} onLoad={onLoad} onError={onError} $isHidden={hasError} />
    </ImageContainer>
  )
}

export const FileFieldDisplay = (props: Props) => {
  const { file, renderImages, renderPDFsInline } = props
  const signedUrl = file.url?.signedUrl ?? ''
  if (renderPDFsInline && isPdf(file.type)) {
    return (
      <VStack gap={2}>
        <T.Body>
          <Link externalHref={signedUrl}>{file.name}</Link>
        </T.Body>
        <iframe
          src={signedUrl}
          style={{ border: 'none', height: '100vh', width: '100%' }}
          title="PDF Preview"
        />
      </VStack>
    )
  }
  if (renderImages && isImage(file.type)) {
    return <FileImage signedUrl={signedUrl} />
  }
  return (
    <T.Body>
      <Link externalHref={signedUrl}>{file.name}</Link>
    </T.Body>
  )
}
